var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletewhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11035 20.5316V6.6468C1.11035 3.36285 3.77496 0.698242 7.05891 0.698242H10.4581",
    stroke: "#F3F3F3",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9436 4.24121V16.1383C20.9436 18.5581 18.9703 20.5313 16.5506 20.5313H6.52588",
    stroke: "#F3F3F3",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16602 6.28711L16.7092 16.8159",
    stroke: "#F3F3F3",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.738 6.28711L6.16602 16.8159",
    stroke: "#F3F3F3",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletewhite);
export default __webpack_public_path__ + "static/media/deletewhite.cd1f0ecf2bd50042c082a48aa943b25e.svg";
export { ForwardRef as ReactComponent };